import dayjs from 'dayjs';

/**
 * Same calendar day -> time of day ("2:14 PM"), same calendar year -> short date ("Feb 4"),
 * older -> short date with year ("Dec 18, 2024").
 */
export const formatConversationTimestamp = (updatedAt: string, now: dayjs.Dayjs = dayjs()): string => {
  const target = dayjs(updatedAt);
  if (!target.isValid()) {
    return '';
  }
  if (target.isSame(now, 'day')) {
    return target.format('h:mm A');
  }
  if (target.isSame(now, 'year')) {
    return target.format('MMM D');
  }
  return target.format('MMM D, YYYY');
};
